import { makeStyles } from '@material-ui/core';

export const useTestDetailStyles = makeStyles(() => ({
    ngpBadge: {
        display: 'inline-block',
        pointerEvents: 'none',
        padding: '0 1px',
        fontFamily: 'Roboto, sans-serif',
        fontSize: 12,
        fontWeight: 'bold',
        minWidth: 20,
        width: 'auto',
        height: 20,
        lineHeight: '20px',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: '#FFFFFF',
        backgroundColor: 'rgb(150, 208, 10)',
        borderRadius: 10,
    },
}));
